/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * description
 * @type {Array}
 */
export const COLORS_WHITE_TO_BLACK = [{
	pct: 0.0,
	color: {
		r: 0xf5,
		g: 0xf8,
		b: 0xfa
	}
}, {
	pct: 0.5,
	color: {
		r: 0x89,
		g: 0x8b,
		b: 0x8c
	}
}, {
	pct: 1.0,
	color: {
		r: 0x14,
		g: 0x17,
		b: 0x1a
	}
}];
